import React, { FC } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faXmark } from '@fortawesome/pro-light-svg-icons';

import styles from './index.module.sass';

interface CloseProps {
  onClick: () => void;
}

const Close: FC<CloseProps> = ({ onClick }) => (
  <div className={styles.container}>
    <button className={styles.button} type="button" onClick={onClick}>
      <FontAwesomeIcon icon={faXmark} />
    </button>
  </div>
);

export default Close;
